/***************************************************************
5/27/2017
Alexander Self
Timesheet harvest table
- Displays an employees harvested trees, bags, hours, field
***************************************************************/
import React from 'react';
import { totalCount } from '../../../utils';
const TimesheetHarvestTable = ({ harvest }) => {
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th>Hours</th>
          <th>Trees</th>
          <th>Bags</th>
          <th>Field</th>
          <th>Block</th>
          <th>Round</th>
        </tr>
      </thead>
      <tbody>
        {
          harvest.map((h) => {
            return (
              <tr key={h.id}>
                <td>{ h.hours }</td>
                <td>{ h.trees }</td>
                <td>{ h.bags }</td>
                <td>{ h.field }</td>
                <td>{ h.block }</td>
                <td>{ h.round }</td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center><b>{totalCount(harvest, 'hours')}</b></center></td>
          <td><center><b>{totalCount(harvest, 'trees')}</b></center></td>
          <td><center><b>{totalCount(harvest, 'bags')}</b></center></td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TimesheetHarvestTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_gang_harvest_table.js